var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ListService, Predicate } from './list.service';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ItemBase } from '../../models/item/item-base';
import { ColumnService } from '../../items/columns/column/column.service';
import { Select2ajaxService } from '../../items/columns/select/select2ajax.service';
import { Btn } from '../../models/button/button';
var SearchComponent = /** @class */ (function (_super) {
    __extends(SearchComponent, _super);
    function SearchComponent(router, route, logger, action, message, page, service, columnService, s2Service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.columnService = columnService;
        _this.s2Service = s2Service;
        _this.toggle = false;
        _this.buttons = [];
        _this.predicateList = [];
        _this.conddisp = [];
        _this.dispRec = {};
        _this.events = { search: 'search', search_clear: 'search_clear' };
        _this.checkDateTime = false;
        return _this;
    }
    SearchComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.saveQuery = this.service.setSaveQuery(this.groupName, params.saveQuery);
        this.setInitQuery();
    };
    SearchComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.groupName) {
            // 言語を変更した後にpredicateListを再度セットする
            this.setInitQuery();
        }
    };
    SearchComponent.prototype.setInitQuery = function () {
        var cond = this.service.getCondition(this.groupName);
        if (typeof cond !== 'undefined' && this.saveQuery) {
            this.rec = Object.assign({}, cond.searchRec);
        }
        else {
            this.setInitValue();
        }
        this.checkDateTime = true;
        this.setPredicateList();
        this.checkDateTime = false;
        this.service.getQuery({ predicateList: this.predicateList }, this.groupName);
    };
    SearchComponent.prototype.setInitValue = function () {
        this.rec = Object.assign({}, this.dispRec);
        this.setValueChildren(this.cols);
    };
    SearchComponent.prototype.setValueChildren = function (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.items) {
                this.setValueChildren(col.items);
            }
            else {
                var k = col.key;
                var params = col.params || {};
                if (col.controlType === 'textOperator') {
                    this.setValue(col.key, params.initValue);
                    var operator = params.operator;
                    if (operator && (operator.readonly || operator.hidden)) {
                        this.setValue('$operator.' + col.key, operator.value);
                    }
                    else {
                        this.setValue('$operator.' + col.key, 'eq');
                    }
                }
                else if (col.controlType === 'numberOperator' || col.controlType === 'dateOperator' || col.controlType === 'timeOperator' || col.controlType === 'datetimeOperator') {
                    if (params.match && params.match.initValue) {
                        this.setValue('$match.' + col.key, params.match.initValue);
                    }
                    if (params.rangeFrom && params.rangeFrom.initValue) {
                        this.setValue('$rangeFrom.' + col.key, params.rangeFrom.initValue);
                    }
                    if (params.rangeTo && params.rangeTo.initValue) {
                        this.setValue('$rangeTo.' + col.key, params.rangeTo.initValue);
                    }
                    var op = { radio: 'match', match: 'eq', rangeFrom: 'ge', rangeTo: 'le' };
                    var operator = params.operator;
                    if (operator) {
                        if (typeof operator.range !== 'undefined' && operator.range === false) {
                            op.radio = 'match';
                        }
                        else if (typeof operator.match !== 'undefined' && operator.match === false) {
                            op.radio = 'range';
                        }
                        else if (operator.value) {
                            op.radio = operator.value;
                        }
                        if (operator.rangeFrom && (operator.rangeFrom.readonly || operator.rangeFrom.hidden)) {
                            op.rangeFrom = operator.rangeFrom.value;
                        }
                        if (operator.rangeTo && (operator.rangeTo.readonly || operator.rangeTo.hidden)) {
                            op.rangeTo = operator.rangeTo.value;
                        }
                    }
                    if (op.radio === 'match') {
                        op.rangeFrom = null;
                        op.rangeTo = null;
                    }
                    else {
                        op.match = null;
                    }
                    for (var _a = 0, _b = Object.keys(op); _a < _b.length; _a++) {
                        var key = _b[_a];
                        this.setValue('$operator.$' + key + '.' + col.key, op[key]);
                    }
                }
                else {
                    this.setValue(col.key, params.initValue);
                }
            }
        }
    };
    SearchComponent.prototype.setValue = function (key, val) {
        if (key && typeof val !== 'undefined' && typeof this.rec[key] === 'undefined') {
            this.rec[key] = val;
        }
    };
    SearchComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    SearchComponent.prototype.disableFilter = function () {
        this.rec = {};
        this.dispRec = {};
        this.predicateList = [];
        this.setInitValue();
        this.setPredicateList();
        this.service.getQuery({ predicateList: this.predicateList, page: 1 }, this.groupName);
        this.action.firstAction(this.events.search_clear, { queryGroupName: this.groupName });
    };
    SearchComponent.prototype.enableFilter = function () {
        this.setPredicateList();
        this.service.getQuery({ predicateList: this.predicateList, page: 1 }, this.groupName);
        this.action.firstAction(this.events.search, { queryGroupName: this.groupName });
    };
    SearchComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    SearchComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#Button#search') {
            this.enableFilter();
        }
        else if (e === this.componentName + '#Button#searchClear') {
            this.disableFilter();
        }
    };
    SearchComponent.prototype.setChangeCompData = function (component) {
        this.setButtons(component);
    };
    SearchComponent.prototype.setButtons = function (component) {
        var buttons = [];
        if (this.action.validEvent(this.events.search)) {
            buttons.push(Object.assign(new Btn(), {
                type: 'button',
                event: this.componentName + '#Button#search',
                caption: this.msgSnapshot['SearchConditionComponent.button.search'],
                params: { btnClass: { sm: true } }
            }));
        }
        if (this.action.validEvent(this.events.search_clear)) {
            buttons.push(Object.assign(new Btn(), {
                type: 'button',
                event: this.componentName + '#Button#searchClear',
                caption: this.msgSnapshot['SearchConditionComponent.button.clear'],
                params: { btnClass: { sm: true, type: 'delete' } }
            }));
        }
        this.buttons = buttons;
    };
    SearchComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    SearchComponent.prototype.onChange = function (e) {
        this.rec[e.key] = e.val;
    };
    SearchComponent.prototype.onClick = function (e) {
        this.action.firstAction(e.event, { buttonType: e.type });
    };
    SearchComponent.prototype.setPredicateList = function () {
        var _this = this;
        this.predicateList = [];
        this.conddisp = [];
        var _loop_1 = function (col) {
            var disp = false;
            if (col.items) {
                for (var _i = 0, _a = col.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this_1.formatDateTime(item.key, item.controlType, item.params);
                    var d = this_1.setPredicate(item, this_1.rec[item.key]);
                    disp = disp || d;
                    this_1.setOptions(disp, item);
                }
            }
            else {
                var k_1 = col.key;
                if (col.controlType === 'textOperator') {
                    disp = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: 'text' }), this_1.rec[k_1], this_1.rec['$operator.' + k_1]);
                }
                else if (col.controlType === 'numberOperator' || col.controlType === 'dateOperator' || col.controlType === 'timeOperator' || col.controlType === 'datetimeOperator') {
                    var type = col.controlType.replace(/Operator$/, '');
                    if (this_1.rec['$operator.$radio.' + k_1] === 'match') {
                        this_1.formatDateTime('$match.' + k_1, type, col.params);
                        disp = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: type }), this_1.rec['$match.' + k_1], this_1.rec['$operator.$match.' + k_1]);
                    }
                    else {
                        this_1.formatDateTime('$rangeFrom.' + k_1, type, col.params);
                        this_1.formatDateTime('$rangeTo.' + k_1, type, col.params);
                        var f = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: type }), this_1.rec['$rangeFrom.' + k_1], this_1.rec['$operator.$rangeFrom.' + k_1]);
                        var t = this_1.setPredicate(Object.assign(new ItemBase(), col, { controlType: type }), this_1.rec['$rangeTo.' + k_1], this_1.rec['$operator.$rangeTo.' + k_1]);
                        disp = f || t;
                    }
                }
                else if (col.controlType === 'select2ajax') {
                    var rec = this_1.rec[k_1];
                    if (rec && rec.code) {
                        rec = rec.code;
                    }
                    disp = this_1.setPredicate(col, rec);
                    if (disp) {
                        var option = this_1.s2Service.getOption(this_1.componentName, k_1);
                        if (option && option.code && option.display && option.code === rec) {
                            this_1.rec[k_1] = option;
                        }
                        else if (this_1.rec[k_1] && this_1.rec[k_1].code && this_1.rec[k_1].display) {
                            // do nothing
                        }
                        else {
                            this_1.s2Service.getOptionFromCode(col.dataType, rec).subscribe(function (option) {
                                if (option) {
                                    _this.rec[k_1] = option;
                                    _this.dispRec = Object.assign({}, _this.rec);
                                    _this.service.setCondition(_this.dispRec, _this.groupName);
                                }
                            });
                        }
                    }
                }
                else {
                    this_1.formatDateTime(k_1, col.controlType, col.params);
                    disp = this_1.setPredicate(col, this_1.rec[k_1]);
                    this_1.setOptions(disp, col);
                }
            }
            this_1.conddisp.push(disp);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
            var col = _a[_i];
            _loop_1(col);
        }
        this.dispRec = Object.assign({}, this.rec);
        this.service.setCondition(this.dispRec, this.groupName);
    };
    SearchComponent.prototype.setPredicate = function (col, rec, op) {
        if (op === void 0) { op = ''; }
        var k = col.key;
        if (k && typeof rec !== 'undefined' && rec !== null && rec !== '') {
            var stringOperator = 'eq';
            if (typeof rec === 'string') {
                if (this.isStringValue(rec, col.controlType)) {
                    stringOperator = 'like';
                }
                if (op) {
                    stringOperator = op;
                }
                this.predicateList.push(Object.assign(new Predicate(), {
                    name: k,
                    value: rec,
                    operator: stringOperator,
                    type: col.dataType
                }));
                return true;
            }
            else if (rec instanceof Array) {
                if (rec.length > 0) {
                    this.predicateList.push(Object.assign(new Predicate(), {
                        name: k,
                        values: rec,
                        operator: 'in',
                        type: col.dataType
                    }));
                    return true;
                }
            }
            else {
                if (op) {
                    stringOperator = op;
                }
                this.predicateList.push(Object.assign(new Predicate(), {
                    name: k,
                    value: rec,
                    operator: stringOperator,
                    type: col.dataType
                }));
                return true;
            }
        }
        return false;
    };
    SearchComponent.prototype.isStringValue = function (data, controlType) {
        var isUUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(data);
        if (!isUUID && controlType === 'text') {
            return true;
        }
        else {
            return false;
        }
    };
    SearchComponent.prototype.formatDateTime = function (key, controlType, params) {
        if (!key || !this.rec[key] || (controlType !== 'date' && controlType !== 'time' && controlType !== 'datetime')) {
            return;
        }
        var option = params ? jsonpath.value(params, '$..options.format') : '';
        var format = '';
        if (controlType === 'date') {
            format = option || this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate'] || 'yyyy/MM/dd';
        }
        else if (controlType === 'time') {
            format = option || this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatTime'] || 'HH:mm';
        }
        else if (controlType === 'datetime') {
            format = option || this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format'] || 'yyyy/MM/dd HH:mm';
        }
        format = moment().toMomentFormatString(format);
        var dateTimeKey = "$" + controlType + "." + key;
        if (this.checkDateTime && this.rec[dateTimeKey]) {
            this.rec[key] = moment(this.rec[dateTimeKey]).format(format);
        }
        else {
            this.rec[dateTimeKey] = moment(this.rec[key], format).format();
        }
    };
    /**
     * APIのレスポンスを選択肢としてセットしたときの選択肢の保存と復帰
     * @param disp
     * @param col
     */
    SearchComponent.prototype.setOptions = function (disp, col) {
        if (!col.key || (col.controlType !== 'select' && col.controlType !== 'select2' && col.controlType !== 'radio' && col.controlType !== 'checkbox')) {
            return;
        }
        var key = '$options.' + col.key;
        if (!disp) {
            delete this.rec[key];
            return;
        }
        var options = this.columnService.getRefOptions(this.componentName, col.key);
        if (options) {
            // 検索時: 条件を保持するためにoptionsをセットする
            var opts = [];
            var rec = this.rec[col.key];
            if (rec instanceof Array) {
                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                    var option = options_1[_i];
                    for (var _a = 0, rec_1 = rec; _a < rec_1.length; _a++) {
                        var r = rec_1[_a];
                        if (option.code.toString() === r.toString()) {
                            opts.push(option);
                        }
                    }
                }
            }
            else {
                for (var _b = 0, options_2 = options; _b < options_2.length; _b++) {
                    var option = options_2[_b];
                    if (option.code.toString() === rec.toString()) {
                        opts.push(option);
                    }
                }
            }
            this.rec[key] = opts;
        }
        else if (this.rec[key]) {
            // 復帰時: 条件を復帰して現在の表示条件を表示するためにセットする
            this.columnService.setRefOptions(this.componentName, col.key, this.rec[key]);
        }
    };
    SearchComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'search',
                    template: "<div class=\"filter\" id=\"{{ componentName }}\">\n  <p class=\"filter_trigger\">\n    <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ (msg | async)['SearchConditionComponent.label.title'] }}</span>\n    <i class=\"filter_triggerStatus\" (click)=\"switchToggle()\">{{ (msg | async)['SearchConditionComponent.label.currentCondition'] }}\n      <ng-template [ngIf]=\"predicateList.length > 0\" [ngIfElse]=\"elseBlock\">\n        <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n          <span *ngIf=\"conddisp[index]\" class=\"filter_triggerStatusItem\">{{ col.label }}\n            <span class=\"filter_triggerStatusItemValue\">\n              <ng-template [ngIf]=\"!col.items\">\n                <ng-container [ngSwitch]=\"col.controlType\">\n                  <column-label-operator *ngSwitchCase=\"'textOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'numberOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'dateOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'timeOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-label-operator *ngSwitchCase=\"'datetimeOperator'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\"></column-label-operator>\n                  <column-formlabel *ngSwitchDefault [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec[col.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n                </ng-container>\n              </ng-template>\n              <ng-template ngFor let-item [ngForOf]=\"col.items\" [ngForTrackBy]=\"trackByCol\">\n                <column-formlabel [col]=\"item\" [val]=\"dispRec[item.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n              </ng-template>\n            </span>\n          </span>\n        </ng-template>\n      </ng-template>\n      <ng-template #elseBlock>\n        <span class=\"filter_triggerStatusItem\">{{ (msg | async)['SearchConditionComponent.label.notSet'] }}</span>\n      </ng-template>\n    </i>\n  </p>\n  <form>\n    <div class=\"filter_property filter_property_toggle -p-2\" [style.display]=\"toggle ? 'block': 'none'\">\n      <ul class=\"filter_property_ul\">\n        <li *ngFor=\"let col of cols; trackBy: trackByCol\">\n          <column-search [key]=\"'forminline'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\" (clickCol)=\"onClick($event)\"></column-search>\n        </li>\n        <li *ngIf=\"buttons.length > 0\" class=\"filter_property_btns -break\">\n          <btn [componentName]=\"componentName + '#Button'\" [component]=\"{params: {buttons: buttons}}\"></btn>\n        </li>\n      </ul>\n    </div>\n  </form>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SearchComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService },
        { type: ColumnService },
        { type: Select2ajaxService }
    ]; };
    return SearchComponent;
}(ContentBaseComponent));
export { SearchComponent };
//# sourceMappingURL=search.component.js.map